import { useMutation, useQueryClient } from 'react-query'

import { QUERY_KEYS } from 'src/constants'
import { subscriptionPriceService } from 'src/services/subscription-price.service'
import { IUpdateSubscriptionPriceDto2 } from 'src/types/subscription-price.type'

export const useUpdateSubscriptionPrices = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async (dto: IUpdateSubscriptionPriceDto2) =>
      subscriptionPriceService.updatePrice(dto.id, {
        amount: dto.amount,
        type: dto.type,
        months: dto.months,
        default: dto.default,
      }),
    {
      onSuccess() {
        queryClient.invalidateQueries(QUERY_KEYS.SUBSCRIPTION_PRICES)
      },
    },
  )
}
